<template>
	<div>
		<div>
		    <Card>
		        <Row :gutter="16">
		            <Col span="24">
		                <div class="global-tool-bar">
		                    <div class="left-bar">
		                        <span class="title">营业汇总核对表</span>
								<span style="margin-left:20px;">会员类别:</span>
								<RadioGroup v-model="userType"
								    style="margin-left:4px;"
								    @on-change="onUserTypeChage">
								    <Radio label="F"> <span>外部会员</span></Radio>
								    <Radio label="E"> <span>内部会员</span></Radio>
								</RadioGroup>
		                        <span style="margin-left:20px;">开始结束时间:</span>
		                        <DatePicker type="daterange"
		                            v-model="selectDates"
		                            size="small"
		                            transfer
		                            placement="bottom-end"
		                            placeholder="选择期初和期末时间"
		                            style=" margin-left:4px;width: 200px"></DatePicker>
		
		                        <Button type="primary"
		                            size='small'
		                            class="btns"
		                            shape="circle"
		                            icon="ios-search"
		                            @click="onSearch()">查询</Button>
		                    </div>
		                </div>
		            </Col>
		        </Row>
		
		        <Row :gutter="16"
		            style="margin-top:10px;">
		            <Col span="24">
		            <stand-pagination-table :columns="mainTable.columns"
		                :data="mainTable.data"
		                :extHeight="60"
		                :loading="mainTable.loading"
		                :table-search="mainTable.tableSearch"
		                :table-load-event="getTransactionSumList" />
		            </Col>
		        </Row>
		    </Card>
		</div>
	</div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import { getDayTransactionSum } from '@/api/modules/finance-management/member-transaction';
import { numberToFixed, number2ThousandsFormat } from '@/components/number-input/display-format';
export default {
	    name: 'transaction-sum',
	    components: {
	        StandPaginationTable,
	        SearchCard
	    },
    data() {
        return {
            userType: 'F',
            selectDates: [],
            mainTable: {
                columns: [
                    { title: '项目汇总', key: 'summaryName', width: 100, align: 'center' },
                    { title: '期初余额', key: 'beginValue', width: 120, align: 'center',
                        render: (h, params) => {
							    return h('div', [
							        h('span', {
							            style: {
							                color: 'blue'
							            }
							        }, params.row.beginValue)
							    ]);
                        }
                    },
                    { title: '增加方', align: 'center',
                        children: [
                            { title: '微信充值', key: 'sumInflow', width: 120, align: 'center' },
                            { title: '支付宝充值', key: 'alipaySumInflow', width: 120, align: 'center' },
                            { title: '手工充值', key: 'handmadeSumInflow', width: 120, align: 'center' },
                            { title: '定金转余额汇总', key: 'sumDepositToBalance', width: 120, align: 'center' },
                            { title: '退纸箱汇总', key: 'packgeFeePayBack', width: 120, align: 'center' },
                            { title: '手动定金转余额汇总', key: 'handmadeSumDepositToBalance', width: 120, align: 'center' },
                            { title: '资金库收退款金汇总', key: 'sumRefundBalance', width: 120, align: 'center' }
                        ]
                    },
                    { title: '减少方', align: 'center',
                        children: [
                            { title: '销售支付汇总', key: 'sumSaleConsume', width: 120, align: 'center' },
                            { title: '余额转定金汇总', key: 'sumBalanceToDeposit', width: 120, align: 'center' },
                            { title: '资金库退退款金汇总', key: 'sumConsumeRefundBalance', width: 120, align: 'center' },
                            { title: '配送费支付汇总', key: 'sumDelvieryFee', width: 120, align: 'center' },
                            { title: '包装费支付汇总', key: 'sumPackageFee', width: 120, align: 'center' },
                            { title: '其它汇总', key: 'sumOtherFee', width: 120, align: 'center' }
                        ]
                    },
                    { title: '余额期末', key: 'endValue', width: 120, align: 'center',
                        render: (h, params) => {
							    return h('div', [
							        h('span', {
							            style: {
							                color: 'blue'
							            }
							        }, params.row.endValue)
							    ]);
                        }
                    }
                ],
                data: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
		    let beginDate = this.getThisMonthStart();
		    let endDate = this.getTodayDateString();
		    this.selectDates = [beginDate, endDate];
        this.init();
    },
    methods:{
        getTodayDateString,
        getThisMonthStart,
        init() {
			    this.getTransactionSumList();
        },
        onSearch() {
			    this.getTransactionSumList();
        },
        onUserTypeChage(e){
            this.getTransactionSumList();
        },
        getTransactionSumList(reset = false){
            this.mainTable.data = [];
            this.mainTable.loading = true;
            if (reset) {
				    search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.needExport = 0;
            this.mainTable.tableSearch.userType = this.userType;
            if (this.userType) {
				   search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
				   this.mainTable.tableSearch.filters.enable = true;
				   this.mainTable.tableSearch.filters.conditions.push({
				       name: 'memberType',
				       type: 'eq',
				       value: this.userType
				   });
            }
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            getDayTransactionSum(this.mainTable.tableSearch).then(res => {
				    this.mainTable.loading = false;
				    if (res.code === 0) {
				        let sumInfo = res.data.sumInfo;
				        let totalSumInfo = res.data.sumInfo;
                    this.mainTable.data.push({
                        summaryName:'汇总表取数',
                        beginValue: numberToFixed(totalSumInfo.beginValue, 2),
                        sumInflow: numberToFixed(totalSumInfo.sumInflow, 2),
                        alipaySumInflow: numberToFixed(totalSumInfo.alipaySumInflow, 2),
                        handmadeSumInflow: numberToFixed(totalSumInfo.handmadeSumInflow, 2),
                        sumDepositToBalance: numberToFixed(totalSumInfo.sumDepositToBalance, 2),
                        packgeFeePayBack: numberToFixed(totalSumInfo.packgeFeePayBack, 2),
                        handmadeSumDepositToBalance: numberToFixed(totalSumInfo.handmadeSumDepositToBalance, 2),
                        sumRefundBalance: numberToFixed(totalSumInfo.sumRefundBalance, 2),
                        sumSaleConsume: numberToFixed(totalSumInfo.sumSaleConsume, 2),
                        sumBalanceToDeposit: numberToFixed(totalSumInfo.sumBalanceToDeposit, 2),
                        sumConsumeRefundBalance: numberToFixed(totalSumInfo.sumConsumeRefundBalance, 2),
                        sumDelvieryFee: numberToFixed(totalSumInfo.sumDelvieryFee, 2),
                        sumPackageFee: numberToFixed(totalSumInfo.sumPackageFee, 2),
                        sumOtherFee: numberToFixed(totalSumInfo.sumOtherFee, 2),
                        endValue: numberToFixed(totalSumInfo.endValue, 2)
                    });
						
                    this.mainTable.data.push({
                        summaryName:'原始单取数',
                        beginValue: numberToFixed(sumInfo.beginValue, 2),
                        sumInflow: numberToFixed(sumInfo.sumInflow, 2),
                        alipaySumInflow: numberToFixed(sumInfo.alipaySumInflow, 2),
                        handmadeSumInflow: numberToFixed(sumInfo.handmadeSumInflow, 2),
                        sumDepositToBalance: numberToFixed(sumInfo.sumDepositToBalance, 2),
                        packgeFeePayBack: numberToFixed(sumInfo.packgeFeePayBack, 2),
                        handmadeSumDepositToBalance: numberToFixed(sumInfo.handmadeSumDepositToBalance, 2),
                        sumRefundBalance: numberToFixed(sumInfo.sumRefundBalance, 2),
                        sumSaleConsume: numberToFixed(sumInfo.sumSaleConsume, 2),
                        sumBalanceToDeposit: numberToFixed(sumInfo.sumBalanceToDeposit, 2),
                        sumConsumeRefundBalance: numberToFixed(sumInfo.sumConsumeRefundBalance, 2),
                        sumDelvieryFee: numberToFixed(sumInfo.sumDelvieryFee, 2),
                        sumPackageFee: numberToFixed(sumInfo.sumPackageFee, 2),
                        sumOtherFee: numberToFixed(sumInfo.sumOtherFee, 2),
                        endValue: numberToFixed(sumInfo.endValue, 2)
                    });
						
                    this.mainTable.data.push({
                        summaryName:'核对',
                        beginValue: numberToFixed(totalSumInfo.beginValue, 2) - numberToFixed(sumInfo.beginValue, 2),
                        sumInflow: numberToFixed(totalSumInfo.sumInflow, 2) - numberToFixed(sumInfo.sumInflow, 2),
                        alipaySumInflow:numberToFixed(totalSumInfo.alipaySumInflow, 2) - numberToFixed(sumInfo.alipaySumInflow, 2),
                        handmadeSumInflow: numberToFixed(totalSumInfo.handmadeSumInflow, 2) - numberToFixed(sumInfo.handmadeSumInflow, 2),
                        sumDepositToBalance: numberToFixed(totalSumInfo.sumDepositToBalance, 2) - numberToFixed(sumInfo.sumDepositToBalance, 2),
                        packgeFeePayBack: numberToFixed(totalSumInfo.packgeFeePayBack, 2) - numberToFixed(sumInfo.packgeFeePayBack, 2),
                        handmadeSumDepositToBalance: numberToFixed(totalSumInfo.handmadeSumDepositToBalance, 2) - numberToFixed(sumInfo.handmadeSumDepositToBalance, 2),
                        sumRefundBalance: numberToFixed(totalSumInfo.sumRefundBalance, 2) - numberToFixed(sumInfo.sumRefundBalance, 2),
                        sumSaleConsume: numberToFixed(totalSumInfo.sumSaleConsume, 2) - numberToFixed(sumInfo.sumSaleConsume, 2),
                        sumBalanceToDeposit: numberToFixed(totalSumInfo.sumBalanceToDeposit, 2) - numberToFixed(sumInfo.sumBalanceToDeposit, 2),
                        sumConsumeRefundBalance: numberToFixed(totalSumInfo.sumConsumeRefundBalance, 2) - numberToFixed(sumInfo.sumConsumeRefundBalance, 2),
                        sumDelvieryFee: numberToFixed(totalSumInfo.sumDelvieryFee, 2) - numberToFixed(sumInfo.sumDelvieryFee, 2),
                        sumPackageFee: numberToFixed(totalSumInfo.sumPackageFee, 2) - numberToFixed(sumInfo.sumPackageFee, 2),
                        sumOtherFee: numberToFixed(totalSumInfo.sumOtherFee, 2) - numberToFixed(sumInfo.sumOtherFee, 2),
                        endValue: numberToFixed(totalSumInfo.endValue, 2) - numberToFixed(sumInfo.endValue, 2)
                    });
				        search.globalSetFilterRecordCount(this.mainTable.tableSearch, 1);
				    }
            });
        }
    }
};
</script>

<style>
</style>